
import clsx from "clsx";

export type SkeletonVariant = "text" | "circular" | "rectangular";

export interface SkeletonProps {
  variant?: SkeletonVariant;
  width?: string | number;
  height?: string | number;
  className?: string;
}

const variantClasses: Record<SkeletonVariant, string> = {
  text: "skeleton skeleton-text",
  circular: "skeleton skeleton-circular",
  rectangular: "skeleton skeleton-rectangular",
};

export function Skeleton({
  variant = "text",
  width,
  height,
  className,
}: SkeletonProps) {
  return (
    <div
      className={clsx(variantClasses[variant], className)}
      style={{ width, height }}
    />
  );
}

export default Skeleton;
